module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reports":{"name":"Reports","url":"reports"},"invoices":{"issued":"Issued Invoices"},"forProperty":"for property"},"sl":{"reports":{"name":"Poročila","url":"porocila"},"invoices":{"issued":"Izdani računi"},"forProperty":"nastanitve"}}')
  delete Component.options._Ctor
}
